<script>
export default {
  name: 'BaseButton',

  props: {
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    label: {
      type: [String, null],
      default: null,
      required: false
    }
  }
}
</script>

<template>
  <button
    class="base-button"
    :class="{ disabled }"
    v-on="$listeners"
    v-bind="$attrs"
    role="button"
  >
    <slot name="before" />
    <template v-if="label !== null">{{ label }}</template>
    <slot v-else></slot>
    <slot name="after" />
  </button>
</template>

<style lang="stylus">
// @import '../assets/css/base.styl'

.base-button
  transition ease .2s color, ease .2s background-color, ease .2s border-color
  border 1px solid transparent
  font-weight 500
  cursor pointer
  height 2.2em
  padding-left 2em
  padding-right 2em
  display inline-flex
  align-items center
  justify-content center
  font-size 0.875rem
  
  @media (min-width: 768px)
    font-size 1rem

  &.base-button-solid
    color #fff
    background-color var(--majorColor)
    border-color var(--majorColor)

    &:hover, &:focus, &.hover, &.focus
      color #fff
      background-color var(--mainColor)
      border-color var(--mainColor)

    &.disabled
      background var(--AkGreyscaleLtGrey)
      border-color var(--AkGreyscaleLtGrey)
      color var(--AkGreyscaleMediumLtGrey)

  &.base-button-outline
    color var(--majorColor)
    background-color #fff
    border-color var(--minorColor)

    &:hover, &:focus, &.hover, &.focus
      color #FFF
      background-color var(--mainColor)
      border-color var(--mainColor)

    &.disabled
      border-color var(--AkGreyscaleLtGrey)
      color var(--AkGreyscaleMediumLtGrey)

  &.base-button-reverse
    color var(--majorColor)
    background-color #fff
    border-color transparent

    &:hover, &:focus, &.hover, &.focus
      color #FFF
      background-color var(--mainColor)
      border-color var(--mainColor)

    &.disabled
      color #FFF
      background-color rgba(#fff, .3)

  &.base-button-small
    font-size .8em

  &.disabled
    cursor default
    pointer-events none
</style>
